import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "content"
};
const _hoisted_2 = {
  class: "banner_news",
  style: {
    backgroundImage: 'url(http://www.boyuyinuo.com/webcss/banner_news.jpg)'
  }
};
const _hoisted_3 = {
  class: "banner_news_title acea-row row-center-wrapper"
};
const _hoisted_4 = {
  key: 0
};
const _hoisted_5 = {
  key: 1
};
const _hoisted_6 = {
  class: "banner_news_miaoshu acea-row row-center-wrapper"
};
const _hoisted_7 = {
  key: 0
};
const _hoisted_8 = {
  key: 1
};
const _hoisted_9 = {
  class: "prolist_postion"
};
const _hoisted_10 = {
  key: 0
};
const _hoisted_11 = {
  key: 1
};
const _hoisted_12 = {
  class: "prolist_all acea-row row-top"
};
const _hoisted_13 = {
  class: "prolist_left"
};
const _hoisted_14 = ["onClick"];
const _hoisted_15 = {
  key: 0
};
const _hoisted_16 = {
  key: 1
};
const _hoisted_17 = {
  class: "prolist_right acea-row row-top"
};
const _hoisted_18 = ["onMouseenter", "onClick"];
const _hoisted_19 = {
  class: "anlie_item_box_pic"
};
const _hoisted_20 = {
  class: "anlie_item_box acea-row row-bottom"
};
const _hoisted_21 = {
  key: 0,
  class: "anlie_item_box_btn acea-row row-center-wrapper"
};
const _hoisted_22 = {
  class: "anlie_item_box_yuyue"
};
const _hoisted_23 = {
  key: 0
};
const _hoisted_24 = {
  key: 1
};
const _hoisted_25 = {
  key: 1,
  class: "anlie_item_box_more"
};
const _hoisted_26 = {
  class: "anlie_item_box_title"
};
const _hoisted_27 = {
  class: "anlie_item_box_deso"
};
const _hoisted_28 = {
  key: 2,
  class: "anlie_item_box_txt"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_zrcheader = _resolveComponent("zrcheader");
  const _component_el_image = _resolveComponent("el-image");
  const _component_zrcfooter = _resolveComponent("zrcfooter");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_zrcheader, {
    xzmenu: $data.xzmenu,
    xzlag: $data.xzlag
  }, null, 8, ["xzmenu", "xzlag"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [$data.xzlag == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_4, "PRODUCT")) : _createCommentVNode("", true), $data.xzlag == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_5, "产品中心")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_6, [$data.xzlag == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_7, "It is widely adopted in industries such as high-speed locomotives, automobiles, construction machinery, steel structures, and household appliances")) : _createCommentVNode("", true), $data.xzlag == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_8, "在高速机车、汽车、工程机械、钢结构、家电等行业被广泛采用")) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_9, [$data.xzlag == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_10, "POSTION： HOME > PRODUCT LIST")) : _createCommentVNode("", true), $data.xzlag == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_11, "当前位置： 主页 > 产品列表")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.cate_list, (item_cateson, index_cateson) => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass([$data.id == item_cateson.id ? 'prolist_cidjiacu' : 'prolist_cidzhengchang']),
      onClick: $event => $options.SelectCateSonId(item_cateson.id, 3)
    }, [$data.xzlag == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(item_cateson.cate_name_en), 1)) : _createCommentVNode("", true), $data.xzlag == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(item_cateson.cate_name), 1)) : _createCommentVNode("", true)], 10, _hoisted_14);
  }), 256))]), _createElementVNode("div", _hoisted_17, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.cateproject_list, (item_project, index_project) => {
    return _openBlock(), _createElementBlock("div", {
      class: "anlie_item",
      onMouseenter: $event => $options.handleMouseEnter(item_project.id),
      onMouseleave: _cache[0] || (_cache[0] = $event => $options.handleMouseLeave()),
      onClick: $event => $options.goprojectdetail(item_project.id, 1)
    }, [_createElementVNode("div", _hoisted_19, [_createVNode(_component_el_image, {
      src: item_project.image,
      class: "anlie_item_box_el_image"
    }, null, 8, ["src"])]), _createElementVNode("div", _hoisted_20, [$data.xzfwid == item_project.id ? (_openBlock(), _createElementBlock("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [$data.xzlag == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_23, "SEE MORE")) : _createCommentVNode("", true), $data.xzlag == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_24, "立即查看")) : _createCommentVNode("", true)])])) : _createCommentVNode("", true), $data.xzfwid == item_project.id ? (_openBlock(), _createElementBlock("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, _toDisplayString(item_project.title), 1), _createElementVNode("div", _hoisted_27, _toDisplayString(item_project.deso), 1)])) : _createCommentVNode("", true), $data.xzfwid != item_project.id ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(item_project.title), 1)) : _createCommentVNode("", true)])], 40, _hoisted_18);
  }), 256))])]), _createVNode(_component_zrcfooter, {
    xzlag: $data.xzlag
  }, null, 8, ["xzlag"])]);
}